/**
 * ShowsCtrl controller
 * Show all TV Shows
 */

import moment from 'moment'
import { nbspify } from '../../app/helpers/string'

// controller mixins
ShowsCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * ShowsCtrl controller
 *
 * @class ShowsCtrl
 * @memberof mwApp/shows
 * @see mwApp/shows
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/shows.controller:ShowsCtrl
 */
/* @ngInject */
export default function ShowsCtrl ($scope, $location, Show, UrlPolicy) {
  var vm = this

  /**
   * Is Found indicator
   *
   * @memberof mwApp/shows.controller:ShowsCtrl
   * @type {boolean}
   */
  vm.isFound = true

  /**
   * Loader indicator
   *
   * @memberof mwApp/shows.controller:ShowsCtrl
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Shows list
   *
   * @memberof mwApp/shows.controller:ShowsCtrl
   * @type {models.Show[]}
   */
  vm.shows = []

  vm.onScrollUrlPolicies = UrlPolicy.getPolicies(vm.urlPolicies = [], true)
  vm.getUrlPoliciesForStSelect = function (select) {
    select.open && vm.onScrollUrlPolicies(undefined, { q: select.search })
  }

  // get token generator id from extension
  const { tokenGeneratorId, tokenGeneratorName } = $location.search()

  vm.streamPolicyId = $location.search().streamPolicyId

  /**
   * Playback token generator name
   *
   * @memberof mwApp/shows.controller:ShowsCtrl
   * @type {String}
   */
  vm.tokenGeneratorName = tokenGeneratorName

  vm.tokenFormatter = function (str) {
    return nbspify(str)
  }

  /**
   * Get Shows from backend
   *
   * @memberof mwApp/shows.controller:ShowsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getShows = function (tableState) {
    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }

    const pObject = tableState.search.predicateObject = tableState.search.predicateObject || {}

    // add filter by token generator
    if (tokenGeneratorId) {
      pObject.tokenGeneratorId = tokenGeneratorId
    }

    if (vm.streamPolicyId) {
      pObject.streamPolicyId = vm.streamPolicyId
      vm.streamPolicyId = null
    }

    Show.loadSmart(tableState)
      .then(
        data => {
          vm.shows = data.content
          vm.isFound = !!vm.shows.length

          $scope.loading = false
        }
      )
  }

  /**
   * Delete show
   *
   * @memberof mwApp/shows.controller:ShowsCtrl
   * @param {models.Show} show
   */
  vm.delete = function (show) {
    show._delete()
      .then(() => $scope.$broadcast('refreshTable'))
  }

  /**
   * Generate status by show
   * @param {models.Show} show
   * @return {String}
   */
  vm.generateShowStatus = function (show) {
    if (show.unpublishTime && moment().diff(show.unpublishTime) > 0) {
      return 'pause orange'
    }

    if (show.publishTime) {
      return moment().diff(show.publishTime) > 0 ? 'play green' : 'time'
    }

    return show.enabled ? 'play green' : 'pause orange'
  }
}
